import keyMirror from 'keymirror';
import { CliArgumentEnum, CliArgumentTypeEnum } from '@mark43/cad-api';

export const segmentTypes = keyMirror({
    [CliArgumentTypeEnum.COMMAND.name]: null,
    [CliArgumentEnum.COMMENT.name]: null,
    [CliArgumentEnum.LOCATION.name]: null,
    [CliArgumentEnum.VEHICLE.name]: null,
    [CliArgumentEnum.DATA_EXCHANGE_INQUIRY_PARAMETERS.name]: null,
    [CliArgumentEnum.LICENSE_PLATE.name]: null,
    [CliArgumentEnum.IS_HIGH_PRIORITY.name]: null,
    [CliArgumentEnum.DISPATCH_AREA.name]: null,
    [CliArgumentEnum.DISPATCH_AREA_GROUP.name]: null,
    [CliArgumentEnum.AGENCY_EVENT_RADIO_CHANNELS.name]: null,
    [CliArgumentEnum.MEMBER.name]: null,
    [CliArgumentEnum.AGENCY.name]: null,
    [CliArgumentEnum.CALL_FOR_SERVICE.name]: null,
    [CliArgumentEnum.DISPOSITION.name]: null,
    [CliArgumentEnum.EVENT.name]: null,
    [CliArgumentEnum.UNIT.name]: null,
    [CliArgumentEnum.STATION.name]: null,
    [CliArgumentEnum.ROTATION_SERVICE_TYPE.name]: null,
    [CliArgumentEnum.MESSAGE_GROUP.name]: null,
    [CliArgumentEnum.UNIT_TAG.name]: null,
    [CliArgumentEnum.CALL_TAKER_STATION.name]: null,
    [CliArgumentEnum.TIME.name]: null,
    [CliArgumentEnum.ASSOCIATE_EVENTS.name]: null,
    [CliArgumentEnum.UNASSOCIATE_EVENTS.name]: null,
    [CliArgumentEnum.CAD_REQUEST_PROFILE.name]: null,
    [CliArgumentEnum.PRIMARY_SUBDIVISION.name]: null,
    [CliArgumentEnum.UPDATE_UNIT_STAFF_COUNT.name]: null,
    [CliArgumentEnum.STAFF_COUNT.name]: null,
    [CliArgumentEnum.HOSPITAL.name]: null,
    [CliArgumentEnum.ORI_ALIAS.name]: null,
    [CliArgumentEnum.MESSAGE_RECIPIENT.name]: null,
});

export type SegmentTypeEnumType = keyof typeof segmentTypes;

export const matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
export const WHITESPACE_REGEX = /(\S+)\s*/g;
export const WHITESPACE_ALPHANUMERIC_REGEX = /\s*([A-Za-z0-9]+)(\s|$)/g;
export const TEXT_COMMENTS_REGEX = /\s(,.*)$/g;
